import {
  ACCOUNT_STATUSES,
  ACCOUNT_TIERS,
  LEAD_STATUSES,
  PIPELINE_OWNERS,
  PIPELINE_STAGES,
} from "../accountConstants.js";
import { FormField, FormInput, FormSelect, FormTextarea } from "./FormField.jsx";

export function AccountModalStepAccount({ form, set }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, marginBottom: 24 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: "16px 14px" }}>
        <FormField label="Potential ACV (In Lakhs)" third>
          <FormInput value={form.potentialAcv} onChange={(v) => set("potentialAcv", v)} placeholder="e.g. 300" />
        </FormField>
        <FormField label="Owner" third>
          <FormSelect value={form.owner} onChange={(v) => set("owner", v)} placeholder="—" options={PIPELINE_OWNERS} />
        </FormField>
        <FormField label="Stage" third>
          <FormSelect value={form.stage} onChange={(v) => set("stage", v)} placeholder="—" options={PIPELINE_STAGES} />
        </FormField>
        <FormField label="Who are we talking to" third>
          <FormInput value={form.talkingTo} onChange={(v) => set("talkingTo", v)} placeholder="Contact name" />
        </FormField>
        <FormField label="Designation" third>
          <FormInput value={form.designation} onChange={(v) => set("designation", v)} placeholder="e.g. Head of Procurement" />
        </FormField>
        <FormField label="Key Stakeholders" third>
          <FormInput value={form.keyStakeholders} onChange={(v) => set("keyStakeholders", v)} placeholder="Decision makers" />
        </FormField>
        <FormField label="Lead Status" third>
          <FormSelect value={form.leadStatus} onChange={(v) => set("leadStatus", v)} placeholder="—" options={LEAD_STATUSES} />
        </FormField>
        <FormField label="Asset Type" third>
          <FormInput value={form.assetType} onChange={(v) => set("assetType", v)} placeholder="e.g. 2W, 3W/4W" />
        </FormField>
        <FormField label="Ecosystem Role" third>
          <FormInput value={form.ecosystemRole} onChange={(v) => set("ecosystemRole", v)} placeholder="e.g. Vehicle OEM, Fleet, Finance" />
        </FormField>
        <FormField label="Last Touch Point + with who" third>
          <FormInput value={form.lastTouchPoint} onChange={(v) => set("lastTouchPoint", v)} placeholder="e.g. 26th March — Karthik" />
        </FormField>
        <FormField label="Next Action" third>
          <FormInput value={form.nextAction} onChange={(v) => set("nextAction", v)} placeholder="Follow-up or deliverable" />
        </FormField>
        <FormField label="Expected Close (Month)" third>
          <FormInput value={form.expectedClose} onChange={(v) => set("expectedClose", v)} placeholder="e.g. May" />
        </FormField>
        <FormField label="Solution Required" half>
          <FormInput value={form.solutionRequired} onChange={(v) => set("solutionRequired", v)} placeholder="e.g. CAN + immob" />
        </FormField>
        <FormField label="Comments (About the Discussion)">
          <FormTextarea value={form.discussionComments} onChange={(v) => set("discussionComments", v)} placeholder="Context from recent discussions..." rows={3} />
        </FormField>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        <FormField label="Status" half>
          <FormSelect value={form.status} onChange={(v) => set("status", v)} placeholder="Select Status" options={ACCOUNT_STATUSES} />
        </FormField>
        <FormField label="Tier" half>
          <FormSelect value={form.tier} onChange={(v) => set("tier", v)} placeholder="Select Tier" options={ACCOUNT_TIERS} />
        </FormField>
        <FormField label="Fleet size (assets)" half>
          <FormInput value={form.fleetSize} onChange={(v) => set("fleetSize", v)} placeholder="0" type="number" />
        </FormField>
        <FormField label="MRR (₹ / month)" half>
          <FormInput value={form.mrr} onChange={(v) => set("mrr", v)} placeholder="0" type="number" />
        </FormField>
        <FormField label="Internal notes">
          <FormTextarea value={form.internalNotes} onChange={(v) => set("internalNotes", v)} placeholder="Optional internal notes..." rows={3} />
        </FormField>
      </div>
    </div>
  );
}
